import { DomainSerializer } from '../../../common/domain.serializer';
import { Entidade } from './entidade';

export class EntidadeSerializer extends DomainSerializer<Entidade> {
}
